import { useSelector } from "react-redux"
import { AssessmentRM } from "models/RM"
import { useMutation } from "@tanstack/react-query"
import { saveWordsFetch } from "store/middlewares/words.crud"
import { updateType } from 'keys'
import { useCallback, useContext } from "react"
import { MarkingWordsContext } from "../MarkingWordsContext"

const MarkingWordsCrud = () => {
    const { words } = useSelector(state => state.words)
    const { assessment } = useSelector(state => state.assessment)

    const { mutateAsync: saveWordsRQ, isPending: saveWordsLoading } = useMutation({ mutationFn: saveWordsFetch })

    const saveMarkingWords = useCallback(async () => {
        const nWords = await saveWordsRQ({ assessment, words })
        const wordsWithoutUpdateTypeDelete = nWords.filter(word => word.update_type != updateType.delete)
        let data = new AssessmentRM({
            endPoint: assessment.endPoint,
            timePoint: assessment.timePoint,
            words: wordsWithoutUpdateTypeDelete,
            prosody: assessment.prosody
        })
        return data
    }, [assessment, words])

    return {
        save: saveMarkingWords,
        loading: saveWordsLoading
    }
}

export default MarkingWordsCrud